import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from 'clsx'
import Link from '@material-ui/core/Link'
import moment from 'moment'

import api from "../../../../common/dependencies/utils/Api";
import {GET_SUMMARY_DATA
} from "../../../../common/constants/ApplicationUrl";

import AllSummaryModal from "../../../../common/allSummaryModal";
const useStyles = makeStyles({
  table: {
    
  },
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    paddingTop: '4px',
    paddingBottom: '4px'
  },
  tableFont: {
    fontSize: '16px', 
    fontFamily: 'Montserrat', 
    
  },
  tableInitFont: {
    fontSize: '16px', 
    fontFamily: 'Montserrat', 
    fontWeight: 'bold', 
    color: '#b499c7'
  },
  tableHeader :{
    fontSize: '18px', 
    fontFamily: 'Montserrat', 
    color: '#277acc', 
    fontWeight: 600,
    padding: '10px 0 !important'
  },
  root: {
  },
});

const data = {
    status: 'Completed', 
    date: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    format: 'Offline', 
    link: 'N/A',
    mom: 'Completed',
    hours: 2.5,
    startupRating: 4, 
    mentorRating: 4
}

export default function BasicTable(props) {
  const classes = useStyles();

  const {sessionSummaryList,sessionId,bottleTableItem} =props;
  const [summaryResp, setSummaryResp]=useState();
  const [modalVisibility, setModalVisibility]=useState(false);

  let userRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  

      // let modalValue = sessionSummaryList.find(data => data.sessionId === sessionId);
      // 
  
  const getSummaryMomReturn = (sessionId) => {
    var responseData;
    let data = {
      mentorshipId: props?.mentorshipId,
      sessionId: sessionId,
    };
    api.POST(GET_SUMMARY_DATA, data).then((res) => {
      responseData = res.data.data;
      
      setSummaryResp(responseData)
    });
  };
  
  return (
    <Box className={classes.root}>
      <TableContainer sx={{overflow: 'hidden'}} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={2} className={clsx(classes.tableRightBorder, classes.tableHeader)}>SESSION {props.number}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION STATUS</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{props.data?.sessionStatus}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION DATE</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{moment(props.data?.sessionDate).format('DD-MM-YYYY')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION FORMAT</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{props.data?.sessionFormat === "ONLINE" ? "ON MAARG PLATFORM" : props.data?.sessionFormat}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION DETAILS</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>
                <div className="newuserTooltip">
                  <Link onClick={() => {
                  props.setSessionModalOpen(true)
                  props.setSessionModalData(props.data)
                  }} style={{cursor: 'pointer', textDecoration: 'underline'}} >View Details</Link>
                   <span className="tooltiptext  tooltip-bottom"style={{width:"130px",left:"40px"}}>
                View Details
              </span>
              </div>
                  </TableCell>
              </TableRow>
              
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION HOURS</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{props.data?.sessionDuration}</TableCell>
              </TableRow>
              {
                userRole !== "Mentor" && (
                  <TableRow>
                  <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION RATING BY STARTUP</TableCell>
                  <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{bottleTableItem?.mentorSummary === null ? " " : bottleTableItem?.mentorSummary?.sessionFeedback }</TableCell>
                </TableRow>
                )
              }
            
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION RATING BY MENTOR</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{bottleTableItem?.startupSummary === null ? " " : bottleTableItem?.startupSummary?.sessionFeedback}</TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION RATING BY STARTUP</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{props.data?.startupRating}</TableCell>
              </TableRow> */}
              {/* <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION NOTES</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}><Link onClick={() => {
                                    
                  props.setSummaryModalOpen(true)
                  // props.setsetSummaryModalData(props.sessionSummaryList)
                  props.setSummarySessionId(props.data.scheduleId)
                }} style={{cursor: 'pointer', textDecoration: 'underline'}} >View Summary</Link></TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>SESSION NOTES</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)} >
                <div className="newuserTooltip">
                  <Link onClick={() => {
                                    
                  // props.setShowAllSummary(true)
                  // props.setsetSummaryModalData(props.sessionSummaryList)
                  // props.setSummarySessionId(props.data.scheduleId)
                  getSummaryMomReturn(props.data?.scheduleId)
                  setModalVisibility(true)
                }} style={props?.data?.momMentorSubmitted === true ?{cursor: 'pointer', textDecoration: 'underline',whiteSpace:"nowrap"}:{cursor: 'pointer',whiteSpace:"nowrap"}} >
                                    {props?.data?.momMentorSubmitted === true ? "View Summary" : "---"}
                  
                  </Link>
                
                <span className="tooltiptext  close-summary" style={{left:"2px",top:"-29px"}}>
                View Summary
              </span>
              </div>
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableInitFont)}>DOCUMENT</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}><Link style={{cursor: 'pointer', textDecoration: 'underline'}}>View Document</Link></TableCell>
              </TableRow> */}
          </TableBody>
        </Table>
      </TableContainer>

      <AllSummaryModal
          modalVisibility={modalVisibility}
          setModalVisibility={setModalVisibility}
          summaryData={summaryResp}
          sessionId={props.data?.scheduleId}
          modalDataList={props?.modalDataList}
          parentData={props?.data}
          summaryFullModalData={props?.data}
        />
    </Box>
  );
}
